import { Grid, Button, Typography, Stack } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { useNavigate } from 'react-router-dom';
import { dispatch, useSelector } from '../../../redux/store';
import { setPedidoIdAtual, getRequisicaoAtivaPedido, TAG, STATUS, getPedidoDetalhe } from '../../../redux/slices/pedidos';

export default function BottomButtons() {
	const { pedido } = useSelector((state) => state.pedidos);
	const navigate = useNavigate();
	const agendamentoAtivo = pedido.itens.length > 0 && pedido.tag_id === TAG.NOVO && pedido.pronto_para_match === 'Não'
	const chatAtivo = pedido.requisicao_status_id === STATUS.ACEITO;

	const goToChat = async () => {
		await dispatch(getPedidoDetalhe(pedido.id));
		await dispatch(getRequisicaoAtivaPedido(pedido.id));
		await dispatch(setPedidoIdAtual(pedido.id));
		navigate('/chat');
	}

	const goToAgendamento = async () => {
		await dispatch(setPedidoIdAtual(pedido.id));
		navigate('/agendamento');
	}

	const goToDocumentos = async () => {
		await dispatch(setPedidoIdAtual(pedido.id));
		navigate('/detalhes/documentos');
	}

	return <Grid container xs={12} md={4}>
		<Grid item sx={{ position: 'fixed', bottom: 0, width: '100%', marginTop: (theme) => theme.spacing(2), padding: (theme) => theme.spacing(2), background: (theme) => theme.palette.grey[200] }}>
			<Stack direction='row' sx={{ justifyContent: 'space-around' }}>
				<Button disabled={!agendamentoAtivo} sx={{ flexDirection: 'column', color: 'grey.700' }} onClick={goToAgendamento}>
					<EventIcon />
					<Typography variant='body2'>Agendamento</Typography>
				</Button>
				<Button sx={{ flexDirection: 'column', color: 'grey.700' }} onClick={goToDocumentos}>
					<DescriptionOutlinedIcon />
					<Typography variant='body2'>Documentos</Typography>
				</Button>
				<Button disabled={!chatAtivo} sx={{ flexDirection: 'column', color: 'grey.700' }} onClick={goToChat}>
					<ChatBubbleOutlineIcon />
					<Typography variant='body2' >Chat</Typography>
				</Button>
			</Stack>
		</Grid>
	</Grid>
}